import { Text } from '@belong/ui';
import { clsx } from 'clsx';
import { IconDots, IconPlus, IconWireTransfer } from '@belong/icons';
import { PAYMENT_SCREENS } from 'containercomponents/Modals/PaymentsModal/PaymentsModal';
import PaymentMenuSelectionContainer from 'containers/PaymentSelectionMenuContainer/PaymentMenuSelectionContainer';
import { FEEDBACK_STRINGS } from 'strings/errors.string';
import type { ConsumerPaymentMethodSummaryModel } from './failed-payments.types';
import { FAILED_PAYMENTS_STRINGS } from './failed-payments-strings';
import { PaymentMethodSummary } from './payment-method-summary';

const PAYMENT_MODAL_PROPS = {
  screen: PAYMENT_SCREENS.PAYMENT_SELECTION,
  errorScreenProps: {
    title: FEEDBACK_STRINGS.set_payment_method.error.title,
    ctaLabel: FEEDBACK_STRINGS.set_payment_method.error.ctaLabel,
  },
  successScreenProps: {
    title: FEEDBACK_STRINGS.set_payment_method.success.title,
    ctaLabel: FEEDBACK_STRINGS.set_payment_method.success.ctaLabel,
  },
};

type FailedPaymentMethodSelectorProps = {
  paymentMethod: ConsumerPaymentMethodSummaryModel | null | undefined;
  selectedPaymentAccountUniqueId: string | null;
  paymentType: string;
  onSelectPaymentMethod: (id: string) => void;
  wireTransferSelected?: boolean;
  onSelectWireTransfer?: () => void;
  locked?: boolean;
};

export function FailedPaymentMethodSelector({
  paymentMethod,
  selectedPaymentAccountUniqueId,
  paymentType,
  onSelectPaymentMethod,
  wireTransferSelected = false,
  onSelectWireTransfer,
  locked = false,
}: FailedPaymentMethodSelectorProps) {
  return (
    <div
      className={clsx(
        'w-full',
        locked && 'pointer-events-none [&_*]:!text-dark-gray',
      )}
    >
      <PaymentMenuSelectionContainer
        selectedPaymentMethodId={selectedPaymentAccountUniqueId ?? ''}
        onSelectPaymentMethod={onSelectPaymentMethod}
        paymentType={paymentType}
        paymentModalProps={PAYMENT_MODAL_PROPS}
        showOnlyValidPaymentMethods
        shouldShowAutoSplitPaymentMethod={false}
        onSelectAutoSplitPaymentMethod={() => {}}
        shouldShowWireTransferPaymentMethod={Boolean(onSelectWireTransfer)}
        onSelectWireTransferPaymentMethod={onSelectWireTransfer}
        fitToButton
        onTop
        menuButtonLabel={
          <span className="flex w-full items-center rounded border border-solid border-gray bg-white px-sm py-sm text-left">
            {wireTransferSelected ? (
              <>
                <span className="flex min-w-0 flex-1 items-center gap-[16px]">
                  <IconWireTransfer
                    width={46}
                    height={30}
                    className="h-[30px] w-[46px] shrink-0"
                  />
                  <Text fontWeight="semibold" className="text-navy">
                    {FAILED_PAYMENTS_STRINGS['wire.transfer']}
                  </Text>
                </span>
                <span className="inline-flex px-xs text-navy">
                  <IconDots width={5} height={24} />
                </span>
              </>
            ) : paymentMethod ? (
              <>
                <span className="min-w-0 flex-1">
                  <PaymentMethodSummary paymentMethod={paymentMethod} />
                </span>
                <span className="inline-flex px-xs text-navy">
                  <IconDots width={5} height={24} />
                </span>
              </>
            ) : (
              <span className="flex items-center gap-[16px]">
                <IconPlus width={14} height={14} className="text-navy" />
                <Text fontWeight="semibold" className="text-navy">
                  {FAILED_PAYMENTS_STRINGS['wire.add_method']}
                </Text>
              </span>
            )}
          </span>
        }
      />
    </div>
  );
}
